import { useEffect } from 'react';
import 'broadcastchannel-polyfill';
import { isGrounds, groundsClose } from '@src/public/utils/app';
import { BC_CLOSE_SAME_PAGE } from '@src/public/constants';

const isSupportClose = () => {
    const supportGv = '7.43.0';
    // ios 14 以下不支持, broadcastchannel-polyfill 在 13.5 13.6 会通知自己，导致关闭
    const iosVersion = '14';
    let isSupport = false;

    if (isGrounds) {
        const deviceInfo = window.grounds.getDeviceInfo();
        // os exp: ios_13.5.1
        const os = deviceInfo.getOs();

        if (os.indexOf('ios') !== -1) {
            const currentIosVersion = os.split('_')[1].split('.')[0];
            const gv = deviceInfo.getGv();
            const supportGvList = supportGv.split('.').map(item => parseInt(item));
            const gvList = gv.split('.').map(item => parseInt(item));

            // 增加对于 ios 14 以下的判断
            if (currentIosVersion < iosVersion) {
                return false;
            }

            for (const index in supportGvList) {
                if (supportGvList[index] !== gvList[index]) {
                    isSupport = gvList[index] > supportGvList[index];
                    break;
                } else if (parseInt(index) >= supportGvList.length - 1) {
                    isSupport = true;
                }
            }
        } else {
            isSupport = true;
        }
    }

    return isSupport;
};

// 端内关闭相同页面，防止层级过深
export const useCloseSamePage = () => {
    useEffect(() => {
        // 端内环境下
        if (isSupportClose()) {
            // 获取无查询参数和哈希值的URL
            const { origin, pathname } = window.location;
            const currentUrl = `${origin}${pathname}`;
            // 创建链接到命名频道的对象
            const bc = new BroadcastChannel(BC_CLOSE_SAME_PAGE);

            // 监听广播消息
            bc.onmessage = e => {
                const { data } = e;
                const { url } = data;

                if (url === currentUrl) {
                    groundsClose();
                }
            };

            bc.postMessage({ url: currentUrl });
        }
    }, []);
};
